var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({class:_vm.$style.backButton},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }